import httpClient from '../httpClient';

const queryQuestionValidationCatalog = async (
  query = {},
  page = 1,
  pageSize = 10,
  sortBy = '',
  search = false,
) => {
  let searchBy = '';

  if (search) searchBy = '&filter[search]=' + search;
  if (sortBy) sortBy = '&sort=' + sortBy;

  return await httpClient.get(
    `/question_validation_catalog/?page[number]=${page}&page[size]=${pageSize}${sortBy}${searchBy}`,
    { params: query },
  );
};

export {
  queryQuestionValidationCatalog,
}
